<ng-container *ngIf="isConfirmationDialog; else onlyDone">
    <button tabindex="-1" type="button" id="no" class="btn btn-primary action-confirm-button ml-1" [mat-dialog-close]="noDialogCloseValue" (click)="onNoClick()" [disabled]="doneBtnDisable">
        {{ noBtnTitle | translate }}
    </button>
    <button tabindex="-1" type="button" id="yes" class="btn btn-primary action-confirm-button mr-1" [mat-dialog-close]="yesDialogCloseValue" (click)="onYesClick()" [disabled]="yesBtnDisable">
        {{ yesBtnTitle | translate }}
    </button>
</ng-container>
<ng-template #onlyDone>
    <button tabindex="-1" type="button" id="done" class="btn btn-primary action-confirm-button" [mat-dialog-close]="doneDialogCloseValue" (click)="onDoneClick()" [disabled]="noBtnDisable">
        {{ doneBtnTitle | translate }}
    </button>
</ng-template>
